<div
  class="course-card"
  [class.course-card--locked]="isLocked"
  role="article"
  [attr.aria-label]="ariaLabel"
  >
  <div class="course-card__top">
    <h3 class="course-card__name">{{ courseTrack.name }}</h3>
    <span class="course-card__badge course-card__badge--{{ badgeStatus }}">
      @if (status === 'completed') {
        <svg class="course-card__badge-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none">
          <path d="M3.5 5.75L5 7.25L8 4.25M10.75 5.75C10.75 8.51142 8.51142 10.75 5.75 10.75C2.98858 10.75 0.75 8.51142 0.75 5.75C0.75 2.98858 2.98858 0.75 5.75 0.75C8.51142 0.75 10.75 2.98858 10.75 5.75Z" stroke="#079455" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      }
      {{ statusLabel }}
    </span>
  </div>

  <button
    class="course-card__btn"
    [class.course-card__btn--primary]="isPrimary"
    [class.course-card__btn--disabled]="isLocked"
    [attr.aria-disabled]="isLocked"
    [attr.aria-label]="buttonLabel + ': ' + courseTrack.name"
    [attr.aria-description]="isLocked ? 'Complete the previous course first' : null"
    (click)="onButtonClick()"
    >
    {{ buttonLabel }}
  </button>
</div>
